// Single source of truth for the public paths that have real per-locale
// prerendered URLs (/en/…, /es/…), with French at the un-prefixed root.
// Consumed by SEO.jsx (hreflang/canonical) + LanguageSelector (URL routing).
//
// When adding a path here, also mirror it in:
//   - src/App.js            → a `/:lng<path>` route wrapped in LocaleRoute
//   - scripts/prerender-seo.js → a LOCALE_PAGES entry (translated content)
//   - the sitemap generator  → the LOCALIZED list
export const LOCALIZED_PATHS = new Set([
  "/",
  "/pricing",
  "/about",
  "/use-cases",
  "/blog",
  "/compare",
  "/kits",
  "/prompts",
  "/models",
]);
